// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__Hhl0T","divider":"index_divider__WG4Eq","tenantSelector":"index_tenantSelector__spwD5"};